
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading state for article content
 * Enhanced to look more like actual content
 */
const LoadingState = () => {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Title-like skeleton */}
      <Skeleton className="h-8 w-[85%]" />
      
      {/* Paragraphs */}
      <div className="space-y-4">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[92%]" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[89%]" />
      </div>
      
      {/* Subheader */}
      <Skeleton className="h-6 w-[60%]" />
      
      {/* More paragraphs */}
      <div className="space-y-4">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[94%]" />
        <Skeleton className="h-4 w-[97%]" />
        <Skeleton className="h-4 w-[85%]" />
      </div>
      
      {/* Image placeholder */}
      <Skeleton className="h-52 w-full rounded" />
      
      {/* More paragraphs */}
      <div className="space-y-4">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[91%]" />
        <Skeleton className="h-4 w-[88%]" />
      </div>
    </div>
  );
};

export default LoadingState;
